import { render } from "./App.vue?vue&type=template&id=73577acd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=73577acd&lang=scss"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Ulbi\\BlogApp\\blog_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__